const surveyStatus = {
  VOTING: 'voting',
  VOTED: 'voted',
  CLOSED: 'closed',
  RESULT: 'result',
  QUIZZ_RESULT: 'quizzReults',
}

// const closedSurveyFields = {
//   [surveyStatus.VOTING]: 'isVotingClosed',
//   [surveyStatus.VOTED]: 'isVotedClosed',
//   [surveyStatus.RESULT]: 'isResultClosed',
// }

const surveyTitle = {
  SURVEY: 'ОПРОС',
  SURVEY_RESULT: 'РЕЗУЛЬТАТЫ',
}

const surveyVariantType = {
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
}
import { STATIC_URL } from 'constants/data'
import { INextImageObj } from 'constants/types/common.types'

const imgData: INextImageObj = {
  iconRight: {
    src: `${STATIC_URL}/icons/complete-arrow.svg`,
    width: 16,
    height: 16,
    decoding: 'async',
    loading: 'lazy',
    alt: 'Иконка правильного ответа',
  },
  iconYourChoise: {
    src: `${STATIC_URL}/icons/your-choise.svg`,
    width: 16,
    height: 16,
    decoding: 'async',
    loading: 'lazy',
    alt: 'Иконка неверного ответа',
  },
}

export { surveyStatus, surveyTitle, surveyVariantType, imgData }
